import { queryOptions, useQuery } from '@tanstack/react-query';

import { getContent, getContentByKey } from '@/lib/api/content';

import { queryKeys } from './query-keys-factory';

/**
 * Query Options Factories
 * These define the query configuration for content-related queries
 */
export const contentQueries = {
  /**
   * Get main content with all relations (facebook, google, instagram, contact, horaire)
   */
  main: () =>
    queryOptions({
      queryKey: queryKeys.content.list(),
      queryFn: getContent,
      staleTime: 1000 * 60 * 10, // 10 minutes
      // Don't use suspense or throwOnError - let React Query handle errors globally
      retry: false,
    }),

  /**
   * Get content by specific key
   */
  byKey: (key: string) =>
    queryOptions({
      queryKey: queryKeys.content.detail(key),
      queryFn: () => getContentByKey(key),
      staleTime: 1000 * 60 * 10,
      enabled: !!key,
      retry: false,
    }),
};

/**
 * Query Hooks
 */

/**
 * Hook to fetch main site content
 * Returns content with facebook, google, instagram, contact, and horaire relations
 *
 * Note: Error handling is done globally in QueryProvider, not here
 */
export const useGetContent = () => useQuery(contentQueries.main());

/**
 * Hook to fetch content by specific key
 */
export const useGetContentByKey = (key: string) => useQuery(contentQueries.byKey(key));
